import { render, staticRenderFns } from "./stock_view.vue?vue&type=template&id=04ce0f4a&"
import script from "./stock_view.vue?vue&type=script&lang=js&"
export * from "./stock_view.vue?vue&type=script&lang=js&"
import style0 from "./stock_view.vue?vue&type=style&index=0&id=04ce0f4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports